<ion-header [ngClass]="{'hide-header': hideheader, 'show-header': showheader}">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button defaultHref="/" text=""></ion-back-button>
    </ion-buttons>
    <ion-title>
      {{ event.name }}
    </ion-title>
    <ion-buttons slot="end">
      <ion-button fill="clear" (click)="onConfigureModal()">
        <ion-icon slot="icon-only" name="settings"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content [ngClass]="{'hide-header-content-move':hideheader,'show-header-content-back':showheader}"
    class="tutorial-page">

    <div class="main-block" [ngClass]="{'hide-header-main-block':hideheader,'show-header-main-block':showheader}">
        <div #map id="map" *ngIf="trackingService.options.google"
            [ngClass]="{'hide-header-main-block':hideheader,'show-header-main-block':showheader}">
        </div>
        <div id="map" [ngClass]="{'hide-header-main-leaflet':hideheader,'show-header-main-leaflet':showheader}"
            *ngIf="!trackingService.options.google">
        </div>
    </div>
    <ion-grid class="grid-overlay" [ngClass]="{'bigger-grid':hideheader,'little-grid':showheader}"
        [style.background-color]="bgColor">

        <ion-row *ngIf="warningMessage && !raceFinished">
            <ion-col size="12" class="centered">
                <span *ngIf="!appDetector.isForestApp()" class="large-text" style="color: whitesmoke !important">{{
                    'GO_TO_STARTING_POINT' | translate
                    }}</span>
                <span *ngIf="appDetector.isForestApp()" class="large-text" style="color: black !important">{{
                    'GO_TO_STARTING_POINT' | translate
                    }}</span>
            </ion-col>
            <hr class="white-line">
        </ion-row>
        <ion-row class="total-time">
            <ion-col class="ion-text-center" style="padding-top: 0;">
                <span class="weight-medium" [style.color]="color">{{'TOTAL_TIME' | translate }}</span>
                <br>
                <strong class="font-size-verylarge" [style.color]="color">
                    {{ getCurrentDuration()}}
                </strong>
            </ion-col>
        </ion-row>
        <ion-row>
            <ion-col class="ion-text-center">
                <span class="weight-medium" [style.color]="color">
                    {{ 'CONFIGURATOR_DISPLAY_DISTANCE' | translate | uppercase }}</span>
                <br>
                <strong class="font-size-extralarge" [style.color]="color">{{ getDeepDistance() }}</strong>
                <br>
                <span class="weight-medium" [style.color]="color"
                    *ngIf="distanceUnit.KM == trackingService.options.distanceUnit">
                    KM
                </span>
                <span class="weight-medium" [style.color]="color"
                    *ngIf="distanceUnit.MILES == trackingService.options.distanceUnit">
                    {{ 'DISTANCE_UNIT_MILES' | translate }}
                </span>
            </ion-col>
        </ion-row>
        <ion-row [style.background-color]="bgColor" class="statistic-block">
            <ion-col class="ion-text-center" size="6">
                <span class="weight-medium" [style.color]="color">{{ 'CONFIGURATOR_DISPLAY_SPEED' | translate |
                    uppercase }} </span>
                <br>

                <strong class="font-size-medium" *ngIf="view.average_pace" [style.color]="color">{{
                    getAveragePace(view.average_pace) }}</strong>
                <strong class="font-size-medium" *ngIf="!view.average_pace" [style.color]="color">0</strong>

                <br>
                <span class="weight-medium" [style.color]="color"
                    *ngIf="distanceUnit.KM == trackingService.options.distanceUnit">MIN/KM</span>
                <span class="weight-medium" [style.color]="color"
                    *ngIf="distanceUnit.MILES == trackingService.options.distanceUnit">MIN/{{ 'MILES' | translate
                    }}</span>
            </ion-col>
            <ion-col class="ion-text-center" size="6">
                <span class="weight-medium" [style.color]="color">{{ 'CONFIGURATOR_DISPLAY_SPEED' | translate |
                    uppercase }}</span>
                <br>
                <strong class="font-size-medium" [style.color]="color">{{ getAvSpeed(view.average_speed)
                    }}</strong>
                <br>
                <span class="weight-medium" [style.color]="color"
                    *ngIf="distanceUnit.KM == trackingService.options.distanceUnit">KM/H</span>
                <span class="weight-medium" [style.color]="color"
                    *ngIf="distanceUnit.MILES == trackingService.options.distanceUnit">{{ 'MILES' | translate
                    }}/H</span>
            </ion-col>
        </ion-row>
        <ion-row [style.background-color]=" bgColor" class="margin-auto">
            <ion-col class=" centered" size="3">
                <!-- <button ion-button icon-only clear class="circle-outline people-btn" (click)="openAddParticipansPage()">
                    <ion-icon name="people" [style.color]="colorIcon"></ion-icon>
                </button> -->
                <!-- <button *ngIf="!isHella" ion-button icon-only clear (click)="onMapToggle()">
                    <ion-icon [style.color]="colorIcon" name="ios-map-outline" *ngIf="!isMap"></ion-icon>
                    <ion-icon [style.color]="colorIcon" name="ios-map" *ngIf="isMap"></ion-icon>
                </button> -->
                <ion-button *ngIf="testMode"  fill="clear" (click)="onTest()">
                    <ion-icon slot="icon-only" [style.color]="colorIcon" name="hammer"></ion-icon>
                </ion-button>
            </ion-col>
            <ion-col  size="6" class="flex-space ion-text-center">
                <ion-button *ngIf="!getStarted() && !raceFinished" [style.--background]="color"
                    class="btn-circle round scale-big colored round-big" [disabled]="isPlayDisabled"  fill="clear"
                    (click)="startTrack()">
                    <ion-icon name="play" slot="icon-only" [style.fill]="bgColor" [style.color]="bgColor" class="font-medium center-triangle">
                    </ion-icon>
                </ion-button>
                <ion-button *ngIf="getStarted() && !raceFinished" [style.--background]="color"
                    class=" btn-circle round scale-big colored round-big"  fill="clear" (click)="stop(false)">
                    <ion-icon  slot="icon-only" name="pause" [style.color]="bgColor" [style.fill]="bgColor" class="font-medium"></ion-icon>
                </ion-button>
                <ion-button *ngIf="(!hasDistance || isHella || isEvents) && !raceFinished && stopAllowed"
                    [style.--background]="color" [disabled]="isStopDisabled()" 
                    class="btn-circle round scale-big colored round-big" fill="clear" (click)="fullStop(false)">
                    <ion-icon slot="icon-only" name="square" [style.fill]="bgColor" class="font-medium scale-square">
                    </ion-icon>
                </ion-button>
                <ion-button *ngIf="raceFinished" [style.--background]="color"
                    class="btn-circle round scale-big colored round-big"  fill="clear" (click)="onResultsRedirect()">
                    <ion-icon name="trophy" [style.fill]="bgColor" slot="icon-only" class="font-medium"></ion-icon>
                </ion-button>
            </ion-col>
            <ion-col class="ion-text-center" class="centered" size="3">
                <ion-button fill="clear" class="btn-circle restart-track" (click)="restartTrack()">
                    <ion-icon slot="icon-only" [style.fill]="colorIcon" [style.color]="colorIcon" name="refresh-circle-outline">
                    </ion-icon>
                </ion-button>
            </ion-col>

        </ion-row>

        <!-- <ion-row *ngIf="isHella" style="background-color: #002f5d;">
            <div style="height: 25px;"></div>
        </ion-row> -->

        <!-- <button ion-button (click)="sendDataTEST()">send</button> -->
        <!-- <button ion-button (click)="getTest()">get fastest</button>  -->


    </ion-grid>

</ion-content>